import { RESOURCE_META } from "@/constants/resource-const"
import { useNavigate } from "react-router-dom"
import { monitoringStore } from "./monitoring-store"
import dayjs from "dayjs"
import { useToggleStore } from "@/hooks/use-toggle-store"

const MonitoringHistory = ({ selectedDong, selectedResource }) => {
  const { history } = monitoringStore()

  const navigate = useNavigate()
  const goUnits = (dong, ho, resourceOrigin) => {
    let resource = resourceOrigin
    if (resourceOrigin === "leak") resource = "water"
    const params = new URLSearchParams({ dong, ho, resource }).toString()

    navigate(`./../units?${params}`)
  }

  const { show, toggle } = useToggleStore("monitoring")

  const filteredHistory = history
    .filter((item) => {
      const matchResource = !selectedResource || item.resource === selectedResource

      const matchDong = selectedDong === "all" || item.dong === selectedDong

      return matchDong && matchResource
    })
    .sort((a, b) => dayjs(b.occurredAt).valueOf() - dayjs(a.occurredAt).valueOf())

  return (
    <div className="h-full flex flex-col flex-1">
      <div className="mb-4">
        <h2 className="text-base font-bold text-gray-800">최근 발생 이력</h2>

        {/* <p className="mt-1 text-xs text-gray-400">이상이 감지된 최근 검침 이력입니다</p> */}
        <p className="mt-1 text-xs text-gray-400">최근 검침 이력입니다</p>
      </div>

      <div className="flex-1 overflow-y-auto py-1 pr-1">
        <div className="space-y-1">
          {filteredHistory.map((item) => (
            <button
              key={`${item.occurredAt}-${item.dong}-${item.ho}-${item.resource}`}
              onClick={() => goUnits(item.dong, item.ho, item.resource)}
              className="w-full text-left flex items-center gap-3 rounded-xl px-3 py-2.5 transition hover:bg-gray-50 cursor-pointer"
            >
              <span className="w-20 shrink-0 text-[11px] text-gray-400">{item.occurredAt}</span>

              <div
                className="h-1.5 w-1.5 shrink-0 rounded-full"
                style={{
                  backgroundColor:
                    item.resource === "leak"
                      ? RESOURCE_META.water?.[item.resource]?.colors?.primary
                      : RESOURCE_META?.[item.resource]?.colors?.primary
                }}
              />

              <div className="min-w-0 flex-1">
                <p className="truncate text-xs font-semibold text-gray-700">
                  {item.dong}동 {item.ho}호
                </p>

                <p className="mt-0.5 text-[10px] text-gray-400">{item.label}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      <button
        className="rounded-sm border mt-4 p-1 border-gray-200 hover:bg-gray-100 cursor-pointer"
        onClick={toggle}
      >
        {show ? "닫기" : "펼쳐보기"}
      </button>
    </div>
  )
}

export default MonitoringHistory
